import React from "react"
import PropTypes from "prop-types"
import { ToggleButtonGroup, ToggleButton, Tooltip } from "@mui/material"
import { DOWNLOAD_TYPES } from "hooks/budgeting/useDownloadBudgetConfig"
import DownloadBudgetEnum from "common/DownloadBudgetEnum"
import { toggleButtonStyles } from "components/Documents/StylesAndUtils/CustomStyles"

const FilterToggleButtonGroup = ({ tipo, handleChangeTipo, fromTab }) => {
  const buttons = [
    { label: "Excel", value: DOWNLOAD_TYPES.EXCEL },
    {
      label: "PDF",
      value: DOWNLOAD_TYPES.PDF,
      disabled: fromTab === DownloadBudgetEnum.FROM_HISTORY_CERTIFICATION,
    },
    {
      label: "BC3",
      value: DOWNLOAD_TYPES.BC3,
      hidden: fromTab !== DownloadBudgetEnum.DEFAULT,
    },
  ]

  return (
    <ToggleButtonGroup
      value={tipo}
      onChange={handleChangeTipo}
      exclusive
      sx={toggleButtonStyles}
    >
      {buttons.map(({ label, value, disabled, hidden }) =>
        hidden ? null : disabled ? (
          <Tooltip key={value} title="Próximamente">
            <span>
              <ToggleButton value={value} disabled>
                {label}
              </ToggleButton>
            </span>
          </Tooltip>
        ) : (
          <ToggleButton key={value} value={value}>
            {label}
          </ToggleButton>
        ),
      )}
    </ToggleButtonGroup>
  )
}

FilterToggleButtonGroup.propTypes = {
  tipo: PropTypes.string.isRequired,
  handleChangeTipo: PropTypes.func.isRequired,
  fromTab: PropTypes.number.isRequired,
}

export default FilterToggleButtonGroup
